import Vue from 'vue';

export default function initPermission(store) {
  Vue.directive('permission', {
    inserted(el, binding) {
      const { value } = binding;
      const pagePermission = store.getters.permission.permissionCodes;
      // console.log('pagePermission', pagePermission);
      if (pagePermission) {
        if (pagePermission.includes(value)) {
          return true;
        }
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
      return false;
    },
    updated(el, binding) {
      const { value } = binding;
      const pagePermission = store.getters.permission.permissionCodes;
      if (pagePermission) {
        if (pagePermission.includes(value)) {
          return true;
        }
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
      return false;
    },
  });
  Vue.directive('permissionElse', {
    inserted(el, binding) {
      const { value } = binding;
      const pagePermission = store.getters.permission.permissionCodes;
      if (pagePermission) {
        if (!pagePermission.includes(value)) {
          return true;
        }
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
      return false;
    },
    updated(el, binding) {
      const { value } = binding;
      const pagePermission = store.getters.permission.permissionCodes;
      if (pagePermission) {
        if (!pagePermission.includes(value)) {
          return true;
        }
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
      return false;
    },
  });
}
